 
import { listEstimate, saveEstimate, updateProject, updateGroup, getNewProjectList } from '@/api/enterprise'
import layerContent from './layer-content'
export default {
  components: {
  },
  props: ['info', 'isMove', 'isEdit'],
  data() {    
    return {
        list: [],
        form: {
            project_id: '',
            project_name: '',
            group_id: ''
        },
        layerLoading: false,
    }
  },
  mounted() {
    this.form = this.info
    this.getList()
  },
  methods: {
    save() {
        this.$refs['form'].validate( async (valid) => {
            if (valid) {
                this.layerLoading = true
                let res
                if (this.form.project_id) {
                    // if (this.isEdit) {
                    //     res = await updateEstimate({project_name: this.form.estimate_name, id: this.form.id})
                    // } else if (this.isMove) {
                    //     res = await updateGroup({group_id: this.form.group_id, id: this.form.id})
                    // } else {
                    //     res = await updateEstimate({group_id: this.form.group_id, estimate_name: this.form.estimate_name, id: this.form.id})
                    // }
                    const res = await updateProject({project_name: this.form.project_name, group_id: this.form.group_id, project_id: this.form.project_id})                                          
                    if (res.code == 0) {
                        this.$toasted.success('操作成功!',{position: "top-center", duration: 2000})
                    }
                    
                }
                
                this.layerLoading = false
                this.$layer.closeAll()
                this.$parent.fetch() 
            }
            
        })
        
    },
    async getList() {
        const res = await getNewProjectList({})        
        this.list = res.data
        
    },
  }
}
